// extracted by mini-css-extract-plugin
export default {"settings__contents__area":"Settings_settings__contents__area__XyWPc","settings__close":"Settings_settings__close__HBzGK"};